export const toggleArrayValue = <T>(array: T[], value: T, enable: boolean) => {
  if (enable) {
    return [...array, value]
  }
  return array.filter((item) => item !== value)
}
